import isNil from 'lodash/isNil'
import omitBy from 'lodash/omitBy'
import { analytics } from './client'

export type TypedFrontendTracker<TEvents extends { [K in keyof TEvents]: Record<string, unknown> }> = {
  track: <E extends keyof TEvents & string>(event: E, properties: TEvents[E]) => void
}

export const createFrontendTracker = <
  TEvents extends { [K in keyof TEvents]: Record<string, unknown> },
>(): TypedFrontendTracker<TEvents> => ({
  track: (event, properties) => {
    const cleaned = omitBy(properties, isNil)
    try {
      void analytics.then((a) => a.track(event, { ...cleaned, env: process.env.OMNEA_APP_ENV }))
    } catch (error) {
      console.error('Error tracking event', { error })
    }
  },
})
